<template>
<div class="ff-shell flex min-h-screen flex-col items-center justify-center gap-6 bg-[#F7F4EF] px-4 py-10 font-foodflowSans">
    <div class="flex flex-col items-center gap-1.5">
        <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
        <div class="font-foodflowSerif text-[28px] font-semibold text-[#375475]">Food<span class="text-[#61B245]">Flow</span></div>
        <div class="text-[13px] font-medium text-[#64748b]">{{ $t('label.organization_name') }}</div>
    </div>

    <div class="w-full max-w-[440px] rounded-2xl border border-[#EDE8DF] bg-white p-8 shadow-[0_20px_60px_rgba(30,45,61,0.08)]">
        <h1 v-if="$slots.title" class="mb-6 text-center font-foodflowSerif text-[20px] font-semibold text-[#1e2d3d]">
            <slot name="title" />
        </h1>
        <slot />
    </div>
</div>
</template>
